import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Image, Card, Placeholder, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import mockup2 from '../assets/price2.png';
import logo from '../assets/logo.webp';



export default function Prezzi() {

    return (
        <>
            <Helmet>
                <title>Prezzi - Gate 51</title>
                <meta name="description" content="" />
            </Helmet>


            <Container fluid className='py-5 ps-0 pe-0 text-center' style={{ minHeight: '100vh' }}>
                <Link to="/">
                    <Image src={logo} width={200} className='mb-5' />
                </Link>
                <Container fluid='lg' className='text-white text-center'>
                    <h1>I nostri pacchetti</h1>
                    <p>Rivolgersi direttamente al BOX Per: sconto studenti, sconto forze dell’ordine, lezioni one to one e promozioni ai nuovi iscritti</p>
                    <Row className='mt-5'>
                        <Col xs={12} sm={6} md={4} className='mb-4'>
                            <Card>
                                <Card.Img variant="top" src={mockup2} />
                                <Card.Body>
                                    <Card.Title>
                                        <h2>1 mese</h2>
                                    </Card.Title>
                                    <Row className='mt-3'>
                                        <Col>
                                            <h4>CrossFit e Hyrox</h4>
                                            <h1 className='mt-3'><span className='small text-muted'>€</span> 95<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                        </Col>
                                        <Col>
                                            <h4>Solo Hyrox</h4>
                                            <h1 className='mt-3'><span className='small text-muted'>€</span> 85<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                        </Col>
                                    </Row>
                                    <Row className='mt-4'>
                                        <Col>
                                            <h4>CrossFit Kids</h4>
                                            <h1 className='mt-3'><span className='small text-muted'>€</span> 55<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                        </Col>
                                        <Col>
                                            <h4>CrossFit Senior</h4>
                                            <h1 className='mt-3'><span className='small text-muted'>€</span> 75<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                        </Col>
                                    </Row>
                                    <Row className='mt-4'>
                                        <Col>
                                            <h4>CrossFit, Hyrox e Boulder</h4>
                                            <h1 className='mt-3'><span className='small text-muted'>€</span> 115<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                        </Col>
                                    </Row>
                                    <br/><br/>
                                    <Link to="/contact"><Button variant='warning'>Contattaci ora!</Button></Link>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} className='mb-4'>
                            <Card>
                                <Card.Img variant="top" src={mockup2} />
                                <Card.Body>
                                    <Card.Title>
                                        <h2>3 mesi</h2>
                                    </Card.Title>
                                    <Row className='mt-3'>
                                        <Col>
                                            <h4>CrossFit e Hyrox</h4>
                                            <h1 className='mt-3'><span className='small text-muted'>€</span> 270<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                            <p style={{fontSize: 18}}>€ 90 mese</p>
                                        </Col>
                                        <Col>
                                            <h4>Solo Hyrox</h4>
                                            <h1 className='mt-3'><span className='small text-muted'>€</span> 240<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                            <p style={{fontSize: 18}}>€ 80 mese</p>
                                        </Col>
                                    </Row>
                                    <Row className='mt-4'>
                                        <Col>
                                            <h4>CrossFit Kids</h4>
                                            <h1 className='mt-3'><span className='small text-muted'>€</span> 140<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                            <p style={{fontSize: 18}}>€ 46 mese</p>
                                        </Col>
                                        <Col>
                                            <h4>CrossFit Senior</h4>
                                            <h1 className='mt-3'><span className='small text-muted'>€</span> 210<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                            <p style={{fontSize: 18}}>€ 70 mese</p>
                                        </Col>
                                    </Row>
                                    <Row className='mt-4'>
                                        <Col>
                                            <h4>CrossFit, Hyrox e Boulder</h4>
                                            <h1 className='mt-3'><span className='small text-muted'>€</span> 320<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                            <p style={{fontSize: 18}}>€ 107 mese</p>
                                        </Col>
                                    </Row>
                                    <br/><br/>
                                    <Link to="/contact"><Button variant='warning'>Contattaci ora!</Button></Link>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} className='mb-4'>
                            <Card>
                                <Card.Img variant="top" src={mockup2} />
                                <Card.Body>
                                    <Card.Title>
                                        <h2>6 mesi</h2>
                                    </Card.Title>
                                    <Row className='mt-3'>
                                        <Col>
                                            <h4>CrossFit e Hyrox</h4>
                                            <h1 className='mt-3'><span className='small text-muted'>€</span> 510<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                            <p style={{fontSize: 18}}>€ 85 mese</p>
                                        </Col>
                                        <Col>
                                            <h4>Solo Hyrox</h4>
                                            <h1 className='mt-3'><span className='small text-muted'>€</span> 450<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                            <p style={{fontSize: 18}}>€ 75 mese</p>
                                        </Col>
                                    </Row>
                                    <Row className='mt-4'>
                                        <Col>
                                            <h4>CrossFit, Hyrox e Boulder</h4>
                                            <h1 className='mt-3'><span className='small text-muted'>€</span> 590<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                            <p style={{fontSize: 18}}>€ 98 mese</p>
                                        </Col>
                                    </Row>
                                    <br/><br/>
                                    <Link to="/contact"><Button variant='warning'>Contattaci ora!</Button></Link>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} className='mb-4'>
                            <Card>
                                <Card.Img variant="top" src={mockup2} />
                                <Card.Body>
                                    <Card.Title>
                                        <h2>12 mesi</h2>
                                    </Card.Title>
                                    <Row className='mt-3'>
                                        <Col>
                                            <h4>CrossFit e Hyrox</h4>
                                            <h1 className='mt-3'><span className='small text-muted'>€</span> 960<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                            <p style={{fontSize: 18}}>€ 80 mese</p>
                                        </Col>
                                        <Col>
                                            <h4>Solo Hyrox</h4>
                                            <h1 className='mt-3'><span className='small text-muted'>€</span> 840<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                            <p style={{fontSize: 18}}>€ 70 mese</p>
                                        </Col>
                                    </Row>
                                    <Row className='mt-4'>
                                        <Col>
                                            <h4>CrossFit, Hyrox e Boulder</h4>
                                            <h1 className='mt-3'><span className='small text-muted'>€</span> 1080<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                            <p style={{fontSize: 18}}>€ 90 mese</p>
                                        </Col>
                                    </Row>
                                    <br/><br/>
                                    <Link to="/contact"><Button variant='warning'>Contattaci ora!</Button></Link>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} className='mb-4'>
                            <Card>
                                <Card.Img variant="top" src={mockup2} />
                                <Card.Body>
                                    <Card.Title>
                                        <h2>10 ingressi</h2>
                                    </Card.Title>
                                    <h1 className='mt-4'><span className='small text-muted'>€</span> 120<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                    <br/><br/>
                                    <Link to="/contact"><Button variant='warning'>Contattaci ora!</Button></Link>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} className='mb-4'>
                            <Card>
                                <Card.Img variant="top" src={mockup2} />
                                <Card.Body>
                                    <Card.Title>
                                        <h2>5 ingressi</h2>
                                    </Card.Title>
                                    <h1 className='mt-4'><span className='small text-muted'>€</span> 70<span className='text-muted' style={{ fontSize: 12 }}>.00</span></h1>
                                    <br/><br/>
                                    <Link to="/contact"><Button variant='warning'>Contattaci ora!</Button></Link>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Container>

            <div className='text-center mt-0 mb-5'>
                <Link to="/">
                    <Button variant='outline-secondary' size='lg'>Torna alla home</Button>
                </Link>
            </div>
        </>
    );
};